/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  IAppState,
  IMediaSearchSuggestionModel,
  MediaSuggestionType,
  ROUTES,
  UrlHelper,
  useSelector,
} from "@bms/common";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";

import { useOutsideClick } from "../../../hooks/useOutsideClick";
import { useAppSearch } from "../useAppSearch";

import "./SearchSuggestions.scss";

export const SearchSuggestions = () => {
  const [filteredSuggestions, setFilteredSuggestions] = useState<
    IMediaSearchSuggestionModel[]
  >([]);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionsContainerRef = useRef<HTMLDivElement>(null);

  const history = useHistory();

  const { searchQuery } = useAppSearch();

  const queryExists = Boolean(searchQuery.query);

  useOutsideClick(suggestionsContainerRef, () => setShowSuggestions(false));

  const suggestions = useSelector(
    (state: IAppState) => state.media.mediaSearch.Suggestions,
  );

  useEffect(() => {
    const pickedFilters = [MediaSuggestionType.Phrase];

    pickedFilters.map((filter) => {
      const filterSuggestions =
        suggestions?.filter((suggestion) => suggestion.TypeCode === filter) ||
        [];
      setFilteredSuggestions((prevFilteredSuggesitons) => [
        ...prevFilteredSuggesitons,
        ...filterSuggestions,
      ]);
      setShowSuggestions(queryExists && filterSuggestions.length > 0);
    });
  }, [queryExists, suggestions]);

  const onSuggestionClick = (value: string | undefined) => {
    setFilteredSuggestions([]);
    setShowSuggestions(false);
    history.replace({
      pathname: ROUTES.SEARCH_SCREEN,
      search: UrlHelper.joinQueries({
        query: value,
        suggestion: true,
      }),
    });
  };

  if (showSuggestions && filteredSuggestions.length > 0) {
    return (
      <div
        className="SearchSuggestions__Container"
        ref={suggestionsContainerRef}
      >
        {filteredSuggestions?.map((filteredSuggestion, index) => {
          return (
            <button
              type="button"
              key={`Suggestion-${filteredSuggestion.Value}-${filteredSuggestion.Id}-${index}`}
              className="button-reset SearchSuggestions__Element"
              onClick={() => onSuggestionClick(filteredSuggestion.Value)}
            >
              {filteredSuggestion.Value}
            </button>
          );
        })}
      </div>
    );
  }
};
